
	function SignupForm(settings){
		this.className = "SignupForm";

		this.name = "signup";

		if(!settings) settings = {};

		settings = {
			template: ("template" in settings) ? settings.template : "index",
		};

		this.data = {
			pages: [
				{
					title: "",
					name: settings.template,
					errors: {
						general: "There are errors in your submission, please correct before continuing."
					},
					submissionUrl: "/forms/signup",
				},
				{
					title: "Thanks",
					name: "complete"
				},
			]
		}

		this.setup(settings);
	};
	SignupForm.inheritsFrom( PageForm );

